// @ts-nocheck
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GoogleMapsDirectionLink from "@insite/content-library/Components/GoogleMapsDirectionLink";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import constants from "@store/constants";
import GlobeFill from "@store/Library/Components/Toolkit/Icons/Globe/GlobeFill";
import Navigation2Fill from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Fill";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";

/* Store Custom Code - Start */
import isAbsoluteUrl from "@toolkit/Framework/Common/Utilities/isAbsoluteUrl";
/* Store Custom Code - End */

export interface DealerDetailsHeaderProps extends WidgetProps {}

export interface DealerDetailsHeaderStyles {
    googleMapsDirectionLink?: LinkPresentationProps;
    visitWebsiteLink?: LinkPresentationProps;
}

export const dealerDetailsHeaderStyles: DealerDetailsHeaderStyles = {
    googleMapsDirectionLink: linkGetActionLinkProps(Navigation2Fill),
    visitWebsiteLink: linkGetActionLinkProps(GlobeFill),
};

const styles = dealerDetailsHeaderStyles;

const DealerDetailsHeader: FC<DealerDetailsHeaderProps> = () => {
    const { value: dealer } = useContext(DealerStateContext);
    const linkBack = usePageLinkByPageType(constants.pageType.locationFinder);

    if (!dealer) {
        return null;
    }

    const websiteUrl = dealer.webSiteUrl?.trim(); // Store Custom Code

    return (
        <OrderHeader title={dealer.name} linkBack={linkBack}>
            {/* Store Custom Code - Start */}
            {websiteUrl && isAbsoluteUrl(websiteUrl) && (
                <Link href={websiteUrl} target="_blank" {...styles.visitWebsiteLink}>
                    {translate("Visit Website")}
                </Link>
            )}
            {/* Store Custom Code - End */}
            <GoogleMapsDirectionLink {...styles.googleMapsDirectionLink} {...dealer} />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: DealerDetailsHeader,
    definition: {
        group: "Dealer Details",
        displayName: "Header",
        allowedContexts: ["DealerDetailsPage"],
    },
};

export default widgetModule;
